import React from 'react'
import PropTypes from 'prop-types'

import ProductListClassic from './product-list-classic'
import ProductListEditorial from './product-list-editorial'
import ProductListFamily from './product-list-family'
import ProductListMosaic from './product-list-mosaic'
import ProductListPattern from './product-list-pattern'
import ProductListSearch from './product-list-search'

/**
 * Renders a specific type of product list component based on the category type.
 *
 * @param {Object} props - The component props.
 * @param {string} props.categoryType - The type of category to determine which product list to render.
 * @param {boolean} [props.isSearch=false] - A flag indicating whether the search-specific product list should be rendered.
 *
 * @returns {JSX.Element} A React component corresponding to the specified category type.
 */
const ProductListType = ({categoryType = '', isSearch = false}) => {
    if (isSearch) {
        return <ProductListSearch />
    }

    switch (categoryType) {
        case 'editorial':
            return <ProductListEditorial />
        case 'family':
            return <ProductListFamily />
        case 'mosaic':
            return <ProductListMosaic />
        case 'pattern':
            return <ProductListPattern />
        default:
            return <ProductListClassic />
    }
}

ProductListType.propTypes = {
    categoryType: PropTypes.string,
    isSearch: PropTypes.bool
}

export default ProductListType
